import { FilterMatchMode } from 'primereact/api';

export class DetalleKpiDashboard {
    constructor() {
        this.model = {
            identificacion: {
                header: 'Identificación',
                table: true,
                filter: true,
                sort: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '140px' },
                body: (rowData) => (
                    <div className="flex align-items-center">
                        <span className="font-mono text-600 bg-gray-100 px-2 py-1 border-round text-sm border-1 border-gray-300">
                            <i className="pi pi-id-card mr-2 text-500"></i>
                            {rowData.identificacion}
                        </span>
                    </div>
                )
            },
            nombre_cliente: {
                header: 'Cliente',
                table: true,
                filter: true,
                sort: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '250px' },
                body: (rowData) => (
                    <div className="flex align-items-center gap-3">
                        <div className="bg-gray-100 text-gray-600 border-circle flex align-items-center justify-content-center border-1 border-gray-300" style={{ width: '35px', height: '35px' }}>
                            <i className="pi pi-building text-lg"></i>
                        </div>
                        <span className="font-semibold text-700">{rowData.nombre_cliente}</span>
                    </div>
                )
            },
            fecha_evaluacion: {
                header: 'Fecha Evaluada',
                table: true,
                isDate: true,
                filter: true,
                sort: true,
                style: { minWidth: '130px' },
                body: (rowData) => {
                    if (!rowData.fecha_evaluacion) return <span className="text-400">Sin fecha</span>;
                    // Formato corto y compensación de zona horaria
                    const formattedDate = new Date(rowData.fecha_evaluacion + 'T00:00:00').toLocaleDateString();
                    return (
                        <div className="flex align-items-center gap-2 text-600 font-medium">
                            <i className="pi pi-calendar text-primary"></i>
                            <span>{formattedDate}</span>
                        </div>
                    );
                }
            },
            calificacion_riesgo_inherente: {
                header: 'Riesgo Inherente',
                table: true,
                filter: false,
                sort: true,
                style: { minWidth: '150px' },
                bodyTemplate: 'riesgoTemplate'
            },
            calificacion_riesgo_residual: {
                header: 'Riesgo Residual',
                table: true,
                filter: false,
                sort: true,
                style: { minWidth: '150px' },
                bodyTemplate: 'riesgoTemplate'
            }
        };
    }
}